const MOKA_SERVICE_HOST = process.env.MOKA_SERVICE_HOST

export const API_V1_GET_ROLES = `${MOKA_SERVICE_HOST}/account/v1/roles`



// WEBPACK FOOTER //
// ./app/api/roles/constants.js